module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"disabled":{"processing":"Web Form is not available yet. It has not finished being processed. Please refresh later and try again.","notOpen":"This Form is not accepting new Submissions right now."}}}')
  delete Component.options._Ctor
}
